import cx from 'classnames'
import type React from 'react'

import type { TreeItemVariants } from '@/types'
import { VARIANTS } from '../../constants'
import useActions from '../../hooks/useActions'
import IconPlus from '../../icons/IconPlus'
import cssNode from '../../Node.module.scss'
import BlockContentViewButton from './components/BlockContentViewButton/BlockContentViewButton'
import { Link } from './components/Link'
import css from './Siblings.module.scss'

type Props = {
  nodeId: string
  url?: string
  variant: TreeItemVariants
  readOnly?: boolean
}

const Siblings: React.FC<Props> = ({ nodeId, url, variant, readOnly }) => {
  const { onCreateSibling } = useActions(nodeId)

  const classes = {
    container: cx(css.container, {
      [css.ghost]: variant === VARIANTS.GHOST,
    }),
  }

  return (
    <div className={classes.container}>
      {variant !== VARIANTS.GHOST && (
        <>
          <BlockContentViewButton nodeId={nodeId} />

          {url && <Link url={url} />}
        </>
      )}

      {!readOnly && (
        <div
          className={cx(cssNode.actionButton, 'node-button-sibling')}
          onClick={onCreateSibling}
        >
          <IconPlus />
        </div>
      )}
    </div>
  )
}

export default Siblings
